import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useClerk } from '@clerk/clerk-react';
import OrganizationSetup from '../partials/onboarding/signup/OrganizationSetup';
import { CREATE_ORGANIZATION_INTENT } from '../utils/onboardingPaths';
import {
  getOrganizationActivationRedirectUrl,
  navigateAfterOrganizationCreation,
} from './signupFlowNavigation';

/**
 * SignupFlow — M2 onboarding: org setup wizard body (left column only).
 * App wraps this route in AuthMarketingSplitLayout (slideshow on the right).
 */
function SignupFlow({ getAuthToken, clerkUser, flowMode = 'initial' }) {
  const history = useHistory();
  const clerk = useClerk();
  const organizationActivationRedirectUrl = getOrganizationActivationRedirectUrl({ flowMode });

  /** Return to Clerk's sign-in-or-up entry: must sign out first or it redirects back to onboarding. */
  const handleBackToSignup = useCallback(async () => {
    const signupPath = window.location.pathname.startsWith('/dashboard')
      ? '/dashboard/signup'
      : '/signup';
    const redirectUrl = `${window.location.origin}${signupPath}`;
    await clerk.signOut({ redirectUrl });
  }, [clerk]);

  const handleComplete = (orgData) => {
    navigateAfterOrganizationCreation({ flowMode, orgData, history });
  };

  const handleCancelAdditionalOrganization = useCallback(() => {
    // This route is launched from the dashboard by an already-onboarded user.
    // Keep its scoped draft so they can resume later, but always offer a safe
    // route back to their existing workspace.
    history.push('/');
  }, [history]);

  return (
    <div className="w-full max-w-lg mx-auto">
      <OrganizationSetup
        key={flowMode}
        clerkUser={clerkUser}
        getAuthToken={getAuthToken}
        onComplete={handleComplete}
        organizationActivationRedirectUrl={organizationActivationRedirectUrl}
        onCancel={
          flowMode === CREATE_ORGANIZATION_INTENT ? handleCancelAdditionalOrganization : undefined
        }
        flowMode={flowMode}
      />
    </div>
  );
}

export default SignupFlow;
